import React from "react";
import { CustomerCaptureOverlay } from "web/react/components/customer-capture-overlay/customer-capture-overlay";
import { container } from "web/react/emo/utilities.css";
import { VStack } from "web/react/emo/v-stack";
import { View } from "web/react/emo/view";
import environment from "web/script/modules/environment";
import {
    InStockAffiliateProductLayoutSerializer,
    ProductAreaSerializer,
} from "web/types/serializers";
import { Breadcrumbs } from "./breadcrumbs/breadcrumbs";
import { Footer } from "./footer/footer";
import InStockProductPageContextProvider from "./in-stock-product-page.context";
import { wrapper } from "./in-stock-product-page.css";
import ProductArea from "./product-area/product-area";
import ProductPriceComparison from "./product-price-comparison/product-comparison";
import { SuggestedProduct } from "./suggested-product/suggested-product";

export interface InStockAffiliateProductPageProps {
    productArea: ProductAreaSerializer;
    productLayout: InStockAffiliateProductLayoutSerializer;
    helpCentreURLs: string[];
}

function InStockProductPage({
    productArea,
    productLayout,
    helpCentreURLs,
}: InStockAffiliateProductPageProps): JSX.Element {
    return (
        <>
            <InStockProductPageContextProvider initialData={{ productArea, productLayout }}>
                <CustomerCaptureOverlay />
                <View className={container} marginTop={"xl"}>
                    <View className={wrapper}>
                        <VStack spacing="md">
                            <Breadcrumbs productLayout={productLayout} />
                            {productArea && <ProductArea />}
                        </VStack>
                        {environment.getFeature("cw_pdp_redesign_phase_2") && (
                            <ProductPriceComparison />
                        )}
                    </View>
                    <SuggestedProduct productLayout={productLayout} />
                </View>
                <Footer productLayout={productLayout} helpCentreURLs={helpCentreURLs} />
            </InStockProductPageContextProvider>
        </>
    );
}

export default InStockProductPage;
